import { createRouter, createWebHistory } from 'vue-router'
import viewRoutes from './views'
import pageRoutes from './pages'
import { useTagStore } from '@/stores/tag'
import { getSession } from '../utils/store'
import { useCommonStore } from '../stores/common'
import pinia from '../stores/pinia'

const commonStore = useCommonStore(pinia)

const router = createRouter({
    history: createWebHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
    routes: [
      ...pageRoutes,
      ...viewRoutes]
  }
)

router.beforeEach(async (to, from, next) => {
  const meta = to.meta || {}
  
  const sysTitle = commonStore.systemConfigs.sysTitle || commonStore.website.title
  const label = meta.title || to.query.name || to.name

  document.title = label ? `${label}——${sysTitle}` : sysTitle

  const isAuthenticated = getSession({ name: 'access_token' })
  // 转去首页，如果已经登录了
  if (to.path === '/login' && isAuthenticated) {
    return next('/')
  }

  // 转去登录页面，如果没有登录
  if (meta.isAuth && to.path !== '/login' && !isAuthenticated) {
    return next('/login')
  }

  const value = to.query.src || to.fullPath

  // 针对外链跳转
  if (value.includes('http') || value.includes('https')) {
    return window.open(value, '_blank')
  }

  if (meta.isTab !== false && value && label) {
    useTagStore().addTag({
      label: label,
      value: value,
      params: to.params,
      query: to.query,
      group: []
    })
  }

  next()
})

export default router